import { palettes } from "../../../../common/themes/palletes"

export const mainCont = {
    width: {mobile: 200, tablet: 459},
    color: "primary.main",
    margin: "20px",
    gap: "18px",
}

export const filterTypeItem = {
    width: "100%",
    height: "44px",
    border: "1px solid",
    borderColor: "primary.main",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    '&:hover': {
        backgroundColor: palettes.$textLightSubtle,
    }
}


export const clientStatusCont = {
    width: "100%",
    border: "1px solid",
    borderColor: "primary.main",
    borderRadius: "12px",
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    px: "32px",
    py: "10px"
}

export const checkBoxPr = {
    margin: "5px",
    borderRadius: "10px",
    '&.Mui-checked': {
        color: "secondary.main",
    },
}

export const checkBoxCont = {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    padding: "10px"
}

export const buttonCont = {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "end"
}

export const filterCont = {
    border: "1px solid",
    borderColor: "primary.main",
    display: "inline-flex",
    alignItems: "center",
    py: "3px",
    px: "10px",
    gap: "18px",
    borderRadius: "12px"
}